import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

/**
 * Abstracts methods and implementation for debouncing an event.
 */
@Directive()
export abstract class DebounceDirective implements OnInit, OnDestroy {
  /**
   * The debounce time in milliseconds.
   */
  @Input() debounceTime = 300;

  /**
   * The callback that will be triggered once the debounce time has passed.
   */
  @Output() debouncedEvent: EventEmitter<any> = new EventEmitter<any>();

  protected stream$: Subject<any> = new Subject<any>();
  protected subscription!: Subscription;

  constructor() {}

  ngOnInit(): void {
    this.startStream();
  }

  ngOnDestroy(): void {
    this.stopStream();
  }

  public startStream(): void {
    this.stopStream();
    this.stream$ = new Subject<any>();
    this.subscription = this.stream$.pipe(debounceTime(this.debounceTime), distinctUntilChanged()).subscribe({
      next: value => this.emitChange(value)
    });
  }

  public stopStream(): void {
    this.subscription?.unsubscribe();
    this.stream$?.complete();
  }

  public emitChange(value: any): void {
    this.debouncedEvent.emit(value);
  }

  public debounceEvent(event: any): void {
    this.stream$.next(event);
  }
}
